import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LogOut, ArrowLeftRight, LayoutDashboard, Users, PhoneCall, BarChart3, Settings } from 'lucide-react';
import OrgBottomNav from '@/components/OrgBottomNav';
import OrgDashboard from '@/components/OrgDashboard';
import OrgFarmers from '@/components/OrgFarmers';
import OrgRequests from '@/components/OrgRequests';
import OrgAnalytics from '@/components/OrgAnalytics';
import OrgSettings from '@/components/OrgSettings';

const SECTION_META = {
  dashboard: { title: 'Overview',  icon: LayoutDashboard },
  farmers:   { title: 'Farmers',   icon: Users },
  requests:  { title: 'Requests',  icon: PhoneCall },
  analytics: { title: 'Analytics', icon: BarChart3 },
  settings:  { title: 'Settings',  icon: Settings },
};

export default function OrgPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [section, setSection] = useState('dashboard');
  const meta = SECTION_META[section];
  const SectionIcon = meta.icon;

  const renderSection = () => {
    switch (section) {
      case 'farmers':   return <OrgFarmers />;
      case 'requests':  return <OrgRequests />;
      case 'analytics': return <OrgAnalytics />;
      case 'settings':  return <OrgSettings />;
      case 'dashboard':
      default:          return <OrgDashboard />;
    }
  };

  return (
    <div
      className="w-full max-w-md mx-auto min-h-screen bg-[#F6F8FB] md:max-w-xl lg:max-w-2xl border-x border-[#E4E8EF]"
      data-testid="org-page"
    >
      <header className="sticky top-0 z-40 bg-[#F6F8FB]/80 backdrop-blur-xl border-b border-[#E4E8EF] px-4 py-3 flex items-center gap-3">
        <SectionIcon className="w-5 h-5 text-[#0B4F3F] flex-shrink-0" />
        <h1 className="text-lg font-semibold text-[#0B1620] font-['Bricolage_Grotesque'] flex-1 min-w-0 truncate">{meta.title}</h1>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            data-testid="org-switch-to-seller-btn"
            onClick={() => navigate('/')}
            className="text-[11px] font-semibold text-[#0B4F3F] bg-[#0B4F3F]/10 hover:bg-[#0B4F3F]/15 rounded-full px-2.5 py-1 flex items-center gap-1 transition-colors"
          >
            <ArrowLeftRight className="w-3.5 h-3.5" /> Seller view
          </button>
          <button
            data-testid="org-logout-btn"
            onClick={logout}
            aria-label="Logout"
            className="w-9 h-9 rounded-full hover:bg-[#B91C1C]/5 text-[#5B6675] hover:text-[#B91C1C] transition-colors flex items-center justify-center"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </header>

      <div className="p-4 pb-24">
        {renderSection()}
      </div>

      <OrgBottomNav active={section} onChange={setSection} />
    </div>
  );
}
